"use client";

import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Electricbullsforsale() {
  const shouldReduceMotion = useReducedMotion();
  const motionProps = shouldReduceMotion ? {
    initial: {
      opacity: 1
    },
    whileInView: {
      opacity: 1
    }
  } : {
    initial: {
      opacity: 0,
      y: 12
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.2
    },
    transition: {
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="inflatable-safety-arenas" data-nav="light" className="py-16 md:py-24 bg-background border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div {...motionProps} className="border border-border bg-card p-6 sm:p-8 md:p-12 relative shadow-xs">
          <div className="flex items-center gap-2 text-primary font-mono text-xs uppercase tracking-wider mb-3">
            <ShieldCheck className="size-4 shrink-0" aria-hidden="true" />
            <span>Safety Surround &amp; Arena Architecture</span>
          </div>

          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-tight text-foreground mb-6">
            Mechanical Bulls With Inflatable Safety Arenas
          </h2>

          <div className="space-y-4 text-muted-foreground font-sans text-base leading-relaxed max-w-3xl mb-8">
            <p>
              Some new mechanical bull packages include or support an inflatable safety arena around the powered ride. Because the mechanical bull and inflatable are separate components, buyers should confirm the arena dimensions, blower requirements, included equipment and setup information for the exact package.
            </p>
            <p>
              Our dedicated Inflatable Mechanical Bulls page explains how to compare complete bull-and-inflatable systems, including package contents, replacement considerations, space and blower requirements.
            </p>
          </div>

          <div className="pt-2">
            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-serif uppercase tracking-wider font-semibold text-sm sm:text-base px-6 py-6 h-auto transition-colors">
              <Link to="/InflatableMechanicalBullsPage" className="inline-flex items-center gap-2">
                <span>VIEW INFLATABLE MECHANICAL BULLS</span>
                <ArrowRight className="size-4 shrink-0" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}